<template>
  <CustomPage title="红包中心" style="background: #f7f7f7">
    <div slot="content" style="height: 100%">
      <div class="allContent">
        <div class="downPullText">
          <span @click="showRedpackRange = true">
            <span>{{ rangeText }} </span
            ><Icon name="arrow-down" color="#808080" size="6"
          /></span>
        </div>
        <div class="redpack-container">
          <!-- //各种类型红包 -->
          <template v-if="Object.keys(redpackList).length > 0">
            <welfareTicketContent
              v-for="(value, keyVaule) in redpackList"
              :key="keyVaule"
              :type="keyVaule"
              :ticketArr="value"
            >
              <div slot="ticketContent">
                <div
                  class="overflow-y-auto"
                  style="max-height: calc(100vh - 120px)"
                >
                  <div
                    v-for="(item, index) in value[1]"
                    :key="index"
                    class="
                      rounded-lg
                      overflow-hidden
                      lightshadow
                      flex flex-row
                      text-white
                      items-center
                      justify-between
                      h-24
                      ticketItemBottom
                    "
                    :style="{
                      backgroundColor:
                        item.redPacketType === 'activity' ||
                        item.redPacketType === 'goods'
                          ? '#fff4f4'
                          : item.redPacketType === 'all'
                          ? '#ffdada'
                          : item.redPacketType === 'store'
                          ? '#ffb4b6'
                          : '#efefef',
                    }"
                  >
                    <div class="ticketItemLeft" style="width: 150px">
                      <div style="display: flex; align-items: center">
                        <span class="text-xl">¥</span
                        ><span
                          class="leading-10 font-semibold"
                          style="letter-spacing: 0.1rem; font-size: 2.5rem"
                          >{{ item.faceValue }}</span
                        >
                      </div>

                      <!-- //如果有满多少可用 ,把正确参数写进来 -->
                      <div v-show="item.fullAmount" class="text-xs">
                        满{{ item.fullAmount }}元可用
                      </div>
                    </div>
                    <div class="text-left flex-grow ml-3">
                      <div class="text-black text-sm mb-1">
                        {{ item.redPacketName }}
                      </div>
                      <div class="text-xs">
                        {{ item.startDate }} - {{ item.endDate }}
                      </div>
                    </div>

                    <div class="ticketRight">
                      <div class="differentRangeTicket">
                        <span>
                          {{
                            item.redPacketType === "activity"
                              ? "活动红包"
                              : item.redPacketType === "goods"
                              ? "商品红包"
                              : item.redPacketType === "all"
                              ? "福利红包"
                              : item.redPacketType === "store"
                              ? "店主红包"
                              : null
                          }}</span
                        >
                      </div>

                      <Button
                        v-if="
                          item.getstatus !== 'got' &&
                          !item.isClaim &&
                          item.remainNum > 0
                        "
                        class="w-12 self-end flex-shrink-0"
                        style="
                          padding-left: 6px;
                          padding-right: 6px;
                          margin-bottom: 1rem;
                          margin-right: 0.75rem;
                        "
                        type="danger"
                        round
                        plain
                        color="red"
                        size="mini"
                        @click="getRedpack(item)"
                        >领取</Button
                      >
                      <Button
                        v-else
                        disabled
                        class="w-12 self-end flex-shrink-0"
                        style="
                          padding-left: 6px;
                          padding-right: 6px;
                          margin-bottom: 1rem;
                          margin-right: 0.75rem;
                          white-space: nowrap;
                        "
                        type="danger"
                        round
                        plain
                        color="red"
                        size="mini"
                        >{{ item.remainNum > 0 ? "已领取" : "已领完" }}</Button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </welfareTicketContent></template
          >
          <Button
            round
            style="background: #e89a52; width: 80%; margin: 0 10%"
            size="large"
            @click="$router.push({ name: 'Redpack' })"
            ><span class="text-white">查看我的红包</span></Button
          >
        </div>
      </div>

      <!-- //各种类型弹框 -->
      <ActionSheet
        v-model="showRedpackRange"
        title="类型"
        :closeable="false"
        class="rangeDialog"
      >
        <div class="m-3 overflow-y-auto" style="max-height: 21rem">
          <Row gutter="20" style="margin-bottom: 10px">
            <Col span="12"
              ><div
                class="typeBorder"
                :class="{ activeTypeBorder: rangeText === '全部类型' }"
                @click="selectedType('全部类型')"
              >
                全部类型{{
                  rangeText === "全部类型" ? "(" + allRangeLength + ")" : ""
                }}
              </div></Col
            >
            <Col span="12">
              <div
                class="typeBorder"
                :class="{ activeTypeBorder: rangeText === '活动红包' }"
                @click="selectedType('活动红包')"
              >
                活动红包{{
                  rangeText === "活动红包" ? "(" + activityLength + ")" : ""
                }}
              </div></Col
            >
          </Row>
          <Row gutter="20" style="margin-bottom: 10px">
            <Col span="12"
              ><div
                class="typeBorder"
                :class="{ activeTypeBorder: rangeText === '全平台福利' }"
                @click="selectedType('全平台福利')"
              >
                全平台福利{{
                  rangeText === "全平台福利" ? "(" + allPlatLength + ")" : ""
                }}
              </div></Col
            >
            <Col span="12">
              <div
                class="typeBorder"
                :class="{ activeTypeBorder: rangeText === '店铺红包' }"
                @click="selectedType('店铺红包')"
              >
                店铺红包{{
                  rangeText === "店铺红包" ? "(" + storeLength + ")" : ""
                }}
              </div></Col
            >
          </Row>
        </div>
        <div class="mx-3 mb-3">
          <Button
            style="padding-left: 12px; padding-right: 12px"
            round
            plain
            color="#e82035"
            size="large"
            @click="showRedpackRange = false"
            >关闭</Button
          >
        </div>
      </ActionSheet>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { getRedpackCenter, getRedpack } from "./webApi";
import { Button, Toast, Icon, ActionSheet, Col, Row } from "vant";
import welfareTicketContent from "@/components/welfareTicketContent";
export default {
  components: {
    CustomPage,
    Button,
    Icon,
    ActionSheet,
    Col,
    Row,
    welfareTicketContent,
  },

  computed: {
    allPlatLength() {
      if (Object.keys(this.allPlatData).length > 0) {
        return this.allPlatData.all[1] ? this.allPlatData.all[1].length : 0;
      }
      return 0;
    },
    activityLength() {
      let sum = 0;
      if (Object.keys(this.activityData).length > 0) {
        for (const item in this.activityData) {
          if (this.activityData[item][1]) {
            sum += this.activityData[item][1].length;
          }
        }
      }
      return sum;
    },

    storeLength() {
      let sum = 0;
      if (Object.keys(this.storeData).length > 0) {
        for (const item in this.storeData) {
          if (this.storeData[item][1]) {
            sum += this.storeData[item][1].length;
          }
        }
      }
      return sum;
    },
    allRangeLength() {
      let sum = 0;
      if (Object.keys(this.redpackList).length > 0) {
        for (const item in this.redpackList) {
          if (this.redpackList[item][1]) {
            sum += this.redpackList[item][1].length;
          }
        }
      }
      return sum;
    },
  },
  data() {
    return {
      redpackList: {},
      showRedpackRange: false,
      rangeText: "全部类型",
      activityData: {},
      storeData: {},
      allPlatData: {},
    };
  },
  created() {
    getRedpackCenter().then(({ data }) => {
      console.log(data);

      // const c = { all: [null, []], a1: ['img', []], a2: ['img', []] }
      const activityData = {};
      const storeData = {};
      const allPlatData = {};
      if (data && data.length > 0) {
        data.map((item) => {
          const activitylArr = [];
          if (item.redPacketType === "activity") {
            activitylArr[1] = item.redPackets;
            activitylArr[0] = item.actBanner;

            activityData[item.actName] = activitylArr;
            this.activityData = activityData;
          } else if (item.redPacketType === "store") {
            activitylArr[1] = item.redPackets;
            activitylArr[0] = item.storeImg;

            storeData[item.storeName] = activitylArr;
            this.storeData = storeData;
          } else if (item.redPacketType === "all") {
            activitylArr[1] = item.redPackets;
            activitylArr[0] = null;

            allPlatData.all = activitylArr;
            this.allPlatData = allPlatData;
          }
        });
        // console.log(
        //   '----this.activityData----',
        //   this.activityData,
        //   '----this.storeData----',
        //   this.storeData,
        //   '----this.allPlatData----',
        //   this.allPlatData
        // )

        this.redpackList = { ...activityData, ...storeData, ...allPlatData };
      }
    });
  },
  watch: {
    rangeText(val) {
      console.log("-----切换到-----" + val);
      let msg;
      if (val === "全部类型") {
        msg = { ...this.activityData, ...this.storeData, ...this.allPlatData };
      } else if (val === "活动红包") {
        msg = this.activityData;
      } else if (val === "全平台福利") {
        msg = this.allPlatData;
      } else if (val === "店铺红包") {
        msg = this.storeData;
      }
      this.redpackList = msg;
    },
  },
  methods: {
    getRedpack(item) {
      getRedpack(item.redPacketId).then((res) => {
        Toast({
          message: res.message,
          position: "center",
          duration: 1000,
        });
        this.$set(item, "getstatus", "got");
      });
    },

    selectedType(type) {
      // alert('类型')

      this.rangeText = type;
      this.showRedpackRange = false;
    },
  },
};
</script>

<style lang="less" scoped>
.allContent {
  .downPullText {
    margin: 24px 0 0 24px;
    font-size: 28px;
    color: #808080;
  }
  .redpack-container {
    .active {
      background-color: #d8283b !important;
      color: #fff;
    }
  }

  .ticketItemBottom {
    margin-bottom: 20px;
    padding-left: 40px;
    color: #e82035;
    &:nth-last-child(1) {
      margin-bottom: 0px;
    }

    .ticketItemLeft {
      .moneySymbol {
        margin-right: 4px;
      }
    }

    .ticketRight {
      height: 100%;

      .differentRangeTicket {
        width: 140px;
        height: 32px;
        background: #ffe3e6;
        border-radius: 0px 12px 0px 12px;
        margin-bottom: 16px;
        font-size: 22px;
        text-align: center;
      }
    }
  }
}

.rangeDialog {
  .typeBorder {
    height: 68px;
    border-radius: 16px;
    border: 2px solid #cfcfcf;
    color: #cfcfcf;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    &.activeTypeBorder {
      border: 2px solid #e82035;
      color: #e82035;
    }
  }
}
</style>
